import { AxisDateWithDay, AxisTime } from "../util/AxisDateTime";
import Table from "react-bootstrap/Table";
import React, { Fragment } from "react";
import { ShiftTypeString } from "../util/ShiftOptionsSelection.js";
import { ShiftTableTitle } from "./ShiftTableTitle";

const ShiftShiftDetailsElement = ({ shift }) => {
  if (shift === null || shift === undefined) return;

  return (
    <Fragment>
      <ShiftTableTitle title={"Shift Detail"} />
      <Table striped hover responsive>
        <tbody>
          <tr>
            <td className={"tdw-50"}>Trust</td>
            <td className={"font-weight-bold"}>{shift?.trust?.name}</td>
          </tr>
          <tr>
            <td>Cost Centre</td>
            <td className={"font-weight-bold"}>
              {shift?.costCentre?.identifier}
            </td>
          </tr>
          <tr>
            <td>Facility</td>
            <td className={"font-weight-bold"}>{shift?.facility?.name}</td>
          </tr>
          <tr>
            <td>Ward</td>
            <td className={"font-weight-bold"}>{shift?.ward?.identifier}</td>
          </tr>
          <tr>
            <td>Ward Proof</td>
            <td className={"font-weight-bold"}>{shift?.rawWard}</td>
          </tr>
          <tr>
            <td>Type</td>
            <td className={"font-weight-bold"}>
              {ShiftTypeString(shift?.shiftType)}
            </td>
          </tr>
          <tr>
            <td>Day</td>
            <td className={"font-weight-bold"}>
              {AxisDateWithDay(shift?.start)}
            </td>
          </tr>

          <tr>
            <td>Start Time</td>
            <td className={"font-weight-bold"}>{AxisTime(shift?.start)}</td>
          </tr>

          <tr>
            <td>End Time</td>
            <td className={"font-weight-bold"}>{AxisTime(shift?.end)}</td>
          </tr>

          <tr>
            <td>Priority</td>
            <td className={"font-weight-bold"}>{shift?.priority}</td>
          </tr>

          <tr>
            <td>Skills</td>
            <td className={"font-weight-bold"}>{shift?.skills}</td>
          </tr>

          <tr>
            <td>Grade</td>
            <td className={"font-weight-bold"}>{shift?.grade}</td>
          </tr>

          <tr>
            <td>Grade Type</td>
            <td className={"font-weight-bold"}>{shift?.gradeType}</td>
          </tr>

          {shift?.secondaryGrade !== "" ? (
            <tr>
              <td>Secondary Grade</td>
              <td className={"font-weight-bold"}>{shift?.secondaryGrade}</td>
            </tr>
          ) : null}

          {shift?.secondaryGradeType?.toLowerCase() !== "unknown" ? (
            <tr>
              <td>Secondary Grade Type</td>
              <td className={"font-weight-bold"}>
                {shift?.secondaryGradeType}
              </td>
            </tr>
          ) : null}
        </tbody>
      </Table>
    </Fragment>
  );
};

export default ShiftShiftDetailsElement;
